import { Reveal } from "../common/Reveal";
import { SocialIcons } from "../common/SocialIcons";

export const CoffeeSection = () => (
  <section className="bg-white py-20 lg:py-24" data-testid="follow-section">
    <div className="container-site">
      <Reveal>
        <div className="flex flex-col items-center gap-6 text-center">
          <p className="eyebrow">Stay connected</p>
          <h2 className="font-serif text-3xl tracking-tight text-navy sm:text-4xl">
            Follow <span className="italic text-emerald">Dr. Irma</span>
          </h2>
          <p className="max-w-md text-sm leading-relaxed text-ink/60">
            Daily reflections, conversations and behind-the-scenes across all platforms.
          </p>
          <SocialIcons className="text-navy" />
        </div>
      </Reveal>
    </div>
  </section>
);
